import { z } from 'zod';

export const syncReconciliationTierKeySchema = z.enum(['high_churn', 'medium_churn', 'low_churn']);

export const syncReconciliationSettingSchema = z.object({
  tierKey: syncReconciliationTierKeySchema,
  enabled: z.boolean(),
  cronExpression: z.string(),
  updatedAt: z.string(),
  updatedBy: z.string().nullable(),
});

export const syncReconciliationSettingsResponseSchema = z.object({
  environment: z.string(),
  settings: z.array(syncReconciliationSettingSchema),
});

export const syncReconciliationTargetSchema = z.object({
  dataType: z.string(),
  tierKey: syncReconciliationTierKeySchema,
  enabled: z.boolean(),
  bulkRelationRefreshEnabled: z.boolean(),
  updatedAt: z.string(),
  updatedBy: z.string().nullable(),
});

export const syncReconciliationTargetsResponseSchema = z.object({
  environment: z.string(),
  targets: z.array(syncReconciliationTargetSchema),
});

export const syncReconciliationSettingPatchSchema = z.object({
  enabled: z.boolean(),
  cronExpression: z.string(),
});

export const syncReconciliationTargetPatchSchema = z.object({
  tierKey: syncReconciliationTierKeySchema,
  enabled: z.boolean(),
  bulkRelationRefreshEnabled: z.boolean().optional(),
});

export const syncReconciliationRunModeSchema = z.enum(['dry_run', 'write_back']);

export const createSyncReconciliationRunInputSchema = z.object({
  bubbleKey: z.string().min(1),
  postgresTableName: z.string().min(1),
  mode: syncReconciliationRunModeSchema,
  windowStart: z.string().min(1),
  windowEnd: z.string().min(1),
  reason: z.string().min(1).optional(),
});

export const syncReconciliationRunSchema = z.object({
  id: z.string(),
  bubbleKey: z.string(),
  postgresTableName: z.string(),
  mode: syncReconciliationRunModeSchema,
  status: z.string(),
  windowStart: z.string(),
  windowEnd: z.string(),
  safetyLagMinutes: z.number(),
  maxActionsPerRun: z.number(),
  maxDeleteActionsPerRun: z.number(),
  maxExactIdActionsPerRun: z.number(),
  maxPagesPerBucket: z.number(),
  maxDurationMs: z.number(),
  bucketMaxAttempts: z.number(),
});

export const createSyncReconciliationRunResponseSchema = z.object({
  environment: z.string(),
  workerJobId: z.string().nullable(),
  run: syncReconciliationRunSchema,
});

export type SyncReconciliationTierKey = z.infer<typeof syncReconciliationTierKeySchema>;
export type SyncReconciliationSetting = z.infer<typeof syncReconciliationSettingSchema>;
export type SyncReconciliationSettingsResponse = z.infer<
  typeof syncReconciliationSettingsResponseSchema
>;
export type SyncReconciliationTarget = z.infer<typeof syncReconciliationTargetSchema>;
export type SyncReconciliationTargetsResponse = z.infer<
  typeof syncReconciliationTargetsResponseSchema
>;
export type SyncReconciliationSettingPatch = z.infer<typeof syncReconciliationSettingPatchSchema>;
export type SyncReconciliationTargetPatch = z.infer<typeof syncReconciliationTargetPatchSchema>;
export type SyncReconciliationRunMode = z.infer<typeof syncReconciliationRunModeSchema>;
export type CreateSyncReconciliationRunInput = z.infer<
  typeof createSyncReconciliationRunInputSchema
>;
export type CreateSyncReconciliationRunResponse = z.infer<
  typeof createSyncReconciliationRunResponseSchema
>;
